import type { Maybe } from 'graphql/jsutils/Maybe';
import type {
  AssetItemConnection,
  TransferTaskProgress,
} from '../../../generated';
import { ReactiveMap } from '../../../utils/ReactiveMap';
import { TransferJobTaskStatus } from './transferJobTaskStatus';

export type TransferJobTaskReactiveMapState = {
  assetId?: string;
  filePath?: string;
  isEncoding?: boolean;
  isPaused?: boolean;
  jobId?: string;
  progress?: TransferTaskProgress;
  status: TransferJobTaskStatus;
  paginatedAssetItems?: Maybe<AssetItemConnection>;
};

export const INITIAL_TRANSFER_JOB_TASK_STATE: TransferJobTaskReactiveMapState =
  {
    status: TransferJobTaskStatus.IDLE,
    progress: null,
    isPaused: false,
    assetId: null,
    jobId: null,
    filePath: null,
    paginatedAssetItems: null,
  };

export const DEFAULT_TRANSFER_JOB_TASK_STATE: TransferJobTaskReactiveMapState =
  {
    status: TransferJobTaskStatus.CANVIEW,
    progress: null,
    isPaused: false,
    assetId: null,
    jobId: null,
    filePath: null,
    paginatedAssetItems: null,
  };

export const transferJobTasksState = new ReactiveMap<
  string,
  TransferJobTaskReactiveMapState
>();
